export const EVENT = {
	userInfo: 'user_info',
	filter: 'filter',
	sortColumns: 'sort_columns',
	clickChart: 'click_chart',
	clickTable: 'click_table',
	buttonClick: 'button_click',
};

export const EVENT_TYPE = {
	clickType: 'click_type',
	sortType: 'sort_type',
	filterType: 'filter_type',
};
